import * as React from "react";
import { Box, Button, Tooltip, TooltipProps } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles';

const ToBeStyledTooltip = ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ tooltip: className }} />
  );

const StyledTooltip = styled(ToBeStyledTooltip)(({ theme }) => ({
    backgroundColor: '#FFFFFF',
    color: '#000000',
    maxWidth: '700px',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #D9D9D9',
    borderRadius: '4px'
  }));

  export interface DataFillToolTipProps {
    content: React.ComponentType<any>;
    infoIconColor?: boolean;
  }

const MaxToolTip: React.FC<DataFillToolTipProps> = ({ content: ContentComponent, infoIconColor=false }) => {

    return (
        <>
        <StyledTooltip
          arrow
          title={
            <Box
              width={700}
            >
              <ContentComponent />
            </Box>
          }
        >
          <Button style={{ minWidth: "1px" }}>
            {infoIconColor ? <InfoOutlinedIcon style={{ color: "white" }} /> : <InfoOutlinedIcon />}

          </Button>
        </StyledTooltip></>
    )
}

export default MaxToolTip;